module.exports = __webpack_public_path__ + "media/images/sarabia-logo-89db5eb1085ec510d001b11d0874ace3.webp";